const hrAr = {
    department: require('../../lang/ar/hr/Department').default,
    employee: require('../../lang/ar/hr/Employee').default,
    group: require('../../lang/ar/hr/Group').default,
    groupType: require('../../lang/ar/hr/GroupType').default,
};

export default hrAr;